import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalClose,
  ModalFooter,
  Icon,
} from '@repo/ui/components'
import { Button } from '@repo/ui/components'
import { useTranslate, MessagesKeys } from '@repo/shared/hooks'
import { USAGE_OPTIONS } from '@repo/shared/store'
import { useState } from 'react'

interface UsageDrawerProps {
  open: boolean
  value: string
  onChange: (value: string) => void
  onClose: () => void
}

export const UsageDrawer = ({
  open,
  value,
  onChange,
  onClose,
}: UsageDrawerProps) => {
  const { t } = useTranslate()

  const [localValue, setLocalValue] = useState(value)
  const handleApply = () => {
    onChange(localValue)
    onClose()
  }
  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className='text-center'>
            {t('filters_usage' as MessagesKeys)}
          </ModalTitle>
          <ModalClose />
        </ModalHeader>
        <div className='flex max-h-[228px] overflow-y-auto flex-col gap-md py-md'>
          {USAGE_OPTIONS.map((opt) => (
            <Button
              key={opt.value}
              variant={localValue === opt.value ? 'ghost' : 'transparent'}
              className='justify-start [&_svg]:fill-unset active:[&_svg]:fill-unset'
              width='full'
              onClick={() => setLocalValue(opt.value)}
            >
              <span className='flex items-center gap-xs'>
                {localValue === opt.value ? (
                  <Icon
                    name='SelectionIndicator'
                    color='fill-unset'
                    size='sm'
                  />
                ) : (
                  <span className='w-5 h-5' />
                )}
                {t(opt.labelKey as MessagesKeys)}
              </span>
            </Button>
          ))}
        </div>
        <ModalFooter>
          <Button onClick={handleApply} className='w-full' variant='fill'>
            {t('filters_apply')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
